import { fieldId } from '../field-id.model';
import { DatosAxisPointer } from './sub-models/datos-axis.model';

export class BaseEchartsSettingsModel<SeriesAggModel> {
  constructor(
    // show the legend on top of the chart
    public series: SeriesAggModel[],
    public show_legend = true,
    public axisPointer: DatosAxisPointer = new DatosAxisPointer(), // pointer on echarts
    public dimensions: fieldId[] = [], // made of uuids
    public breakdowns: fieldId[] = [],
  ) {}
}

export enum MarkTypeEnum {
  Bar = 'bar',
  Line = 'line',
  Area = 'area',
}
